import React from "react";
import { format } from "date-fns";

import DataTable from "../../common/DataTable";
import ColumnHeader from "../../common/ColumnHeader";
import { dateSortComparator } from "../../../utils/date";

const EsimList = ({
  data,
  meta,
  client,
  loading,
  handleSort,
  disableRowClick,
  handlePageChange,
  handleColumnClick,
  handleFilterChange,
  handlePageSizeChange,
  showPwgFields,
  ...props
}) => {
  const columns = [
    { field: "id", headerName: "ID", flex: 1, sortable: false },
    {
      field: "iccid",
      headerName: "ICCID",
      minWidth: 200,
      flex: 3,
      sortable: false,
      renderHeader: (params) =>
        client ? (
          <ColumnHeader
            label={"ICCID"}
            handleClick={() => handleColumnClick("iccid")}
          />
        ) : (
          "ICCID"
        ),
    },
    {
      field: "archive",
      headerName: "Archived",
      sortable: false,
    },
    {
      field: "created_at",
      headerName: "Created At",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.created_at || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
    {
      field: "last_updated",
      headerName: "Last Updated",
      minWidth: 200,
      filterable: false,
      flex: 3,
      sortable: false,
      valueGetter: (params) => params.row.last_updated || null,
      valueFormatter: (params) =>
        params.value &&
        `${format(new Date(params.value), "MMMM d, y hh:mm a")}`,
      sortComparator: dateSortComparator,
    },
  ];

  if (showPwgFields) {
    columns.push(
      {
        field: "imsi",
        headerName: "IMSI",
        minWidth: 160,
        flex: 2,
        sortable: false,
      },
      {
        field: "pin1",
        headerName: "PIN1",
        minWidth: 100,
        sortable: false,
      },
      {
        field: "puk1",
        headerName: "PUK1",
        minWidth: 100,
        sortable: false,
      },
      {
        field: "pin2",
        headerName: "PIN2",
        minWidth: 100,
        sortable: false,
      },
      {
        field: "puk2",
        headerName: "PUK2",
        minWidth: 100,
        sortable: false,
      },
      {
        field: "qr_activation_code",
        headerName: "QR Activation Code",
        minWidth: 260,
        flex: 4,
        sortable: false,
        renderHeader: () => (
          <ColumnHeader
            label={"QR Activation Code"}
            handleClick={() => handleColumnClick("qr_activation_code")}
          />
        ),
      }
    );
  }

  return (
    <DataTable
      disableColumnFilter
      loading={loading}
      data={data}
      columns={columns}
      metaData={meta}
      handlePageChange={handlePageChange}
      handlePageSizeChange={handlePageSizeChange}
      filterMode={client ? "client" : "server"}
      client={client}
      {...props}
    />
  );
};

export default EsimList;
